import { create } from "zustand";

/**
 * Tuzatishdan keyin proyeksiya qayta qurilishini KUTAYOTGAN kunlar.
 *
 * ⚠️⚠️ **Nega umuman kerak.** `POST /attendance/days/{id}/corrections` faqat
 * `attendance_events` qatorini SINXRON yozadi; `attendance_days` proyeksiyasi
 * ASINXRON — `enqueueAttendanceProjection` BullMQ jobini qo'yadi va uni
 * worker keyinroq bajaradi (`attendance.queue.ts`). Tuzatishdan keyingi
 * darhol invalidatsiya deyarli har doim worker'dan OLDIN qaytadi: tasmada
 * yangi hodisa ko'rinadi, `status` / `lateMinutes` / `departuresCount` esa
 * ESKI qiymatlarda qoladi. Keyin yangilanish umuman kelmaydi
 * (`staleTime: 5 daqiqa`, `refetchOnWindowFocus: false`), ya'ni rahbar
 * «tuzatish ishlamadi» deb xulosa qilib QAYTA yuboradi — vaqtni yoki sababni
 * bir oz o'zgartirib. Repozitoriyning tabiiy idempotentlik kaliti
 * (`employee, source, type, occurred_at, reason, corrected_event_id,
 * zone_id`) bunday takrorni USHLAMAYDI va APPEND-ONLY jurnalga ikkinchi
 * qator tushadi: `departure` uchun bu `departures_count = 2` va ikkita
 * ortiqcha `ruxsatsiz_chiqish` buzilishi demakdir.
 *
 * Kalit — `attendance_days.id`, qiymat — tuzatishdan OLDINGI `computedAt`.
 * Proyeksiya qayta qurilganda `computedAt` MAJBURAN o'zgaradi
 * (`rebuildAttendanceDay` butun kunni noldan yozadi), ya'ni bu qiymat
 * «hali eski» degan ishonchli belgidir.
 *
 * ⚠️ Eskirish `events`/`computedAt` taqqoslashidan CHIQARILMAYDI: o'tgan kun
 * uchun kelajakda hech qanday trigger yo'q (`attendance.queue.ts` izohi), ya'ni
 * qonuniy ravishda eskirgan tarixiy kun ABADIY poll qilinardi. Kutish holati
 * faqat «hozir tuzatish yuborildi» hodisasiga bog'lanadi.
 */
interface RecomputeState {
	/** `attendance_days.id` → tuzatishdan OLDINGI `computedAt`. */
	baselines: Record<string, string>;
	markRecomputing: (dayId: string, computedAt: string) => void;
	clearRecomputing: (dayId: string) => void;
}

export const useRecomputeStore = create<RecomputeState>((set) => ({
	baselines: {},

	markRecomputing: (dayId, computedAt) => {
		set((state) => ({ baselines: { ...state.baselines, [dayId]: computedAt } }));
	},

	clearRecomputing: (dayId) => {
		set((state) => {
			if (!(dayId in state.baselines)) {
				return state;
			}

			const { [dayId]: _, ...qolgan } = state.baselines;

			return { baselines: qolgan };
		});
	},
}));

/** Kun proyeksiyasi qayta qurilishini kutmoqdami. */
export function useIsRecomputing(dayId: string | null): boolean {
	return useRecomputeStore((state) => (dayId === null ? false : dayId in state.baselines));
}
